import type { WidgetConfig } from "@/config";
import type { ResolvedHosts, WidgetEnvironment } from "@/types";

export const buildEnvironment = (hosts: ResolvedHosts): WidgetEnvironment => {
  const { kcHostUrl, authHost, cosIdHost } = hosts;

  return {
    requestLoginPage: `${kcHostUrl}/realms/applications/protocol/openid-connect/auth`,
    logoutTarget: `${authHost}/realms/applications/protocol/openid-connect/logout`,
    settingDefaultUrl: `${cosIdHost}/profile/`,
  };
};

export const buildLoginUrl = (env: WidgetEnvironment, cfg: WidgetConfig) => {
  const base = env.requestLoginPage.replace(/\/+$/, "");
  const p = new URLSearchParams();

  p.set("client_id", cfg.clientId);
  p.set("redirect_uri", cfg.redirectUri);
  p.set("response_type", cfg.responseType);
  p.set("scope", cfg.scope);
  p.set("ui_locales", cfg.language ?? "el");

  if (cfg.provisioning) p.set("provisioning", cfg.provisioning);
  if (cfg.codeChallenge) p.set("code_challenge", cfg.codeChallenge);
  if (cfg.codeChallengeMethod)
    p.set("code_challenge_method", cfg.codeChallengeMethod);
  if (cfg.qrCode) p.set("qrCode", cfg.qrCode);
  if (cfg.altTheme) p.set("altTheme", cfg.altTheme);
  if (cfg.state) p.set("state", cfg.state);

  return `${base}?${p.toString()}`;
};

export const buildClientLogoutUrl = (authHost: string, cfg: WidgetConfig) => {
  const qs = new URLSearchParams();
  qs.set("client_id", cfg.clientId);
  qs.set("post_logout_redirect_uri", cfg.logouturl);
  return `${authHost}/realms/applications/client-logout?${qs.toString()}`;
};
